import { useTranslation } from 'react-i18next';
import { useHasPermissions } from '../../helpers/auth-helpers/auth.hooks';
import { Permissions } from '../../helpers/auth-helpers/auth.type';
import { useFeatureFlag } from '../../helpers/feature-flags/feature-flags.hooks';
import { FeatureFlag } from '../../helpers/feature-flags/feature-flags.type';
import type { NavItem } from './side-bar.type';
import { GeneralViewNames } from './side-bar.type';

export function useNavItems(): NavItem[] {
  const i18n = useTranslation();
  const isAgentMinerEnabled = useFeatureFlag(FeatureFlag.AgenticProcessByHooks);
  const hasFinancialsAccess = useHasPermissions(Permissions.FinancialsRead);

  const navItems: NavItem[] = [
    {
      id: GeneralViewNames.Dashboards,
      label: i18n.t('navigation.dashboards'),
      icon: 'dashboard',
      path: '/application/dashboards',
      show: true,
    },
    {
      id: GeneralViewNames.Strategy,
      label: i18n.t('navigation.strategy'),
      icon: 'ads_click',
      path: '/application/strategy',
      show: true,
    },
    {
      id: GeneralViewNames.Financials,
      label: i18n.t('navigation.financials'),
      icon: 'payments',
      path: '/application/financials',
      show: hasFinancialsAccess,
    },
    {
      id: GeneralViewNames.Process,
      label: i18n.t('navigation.process'),
      icon: 'map',
      path: `/application/process/`,
      show: true,
    },
    {
      id: GeneralViewNames.AgentMiner,
      label: i18n.t('navigation.agent_miner'),
      icon: 'terminal',
      path: '/application/agent-miner',
      show: isAgentMinerEnabled,
    },
    {
      id: GeneralViewNames.ProcessAnalysis,
      label: i18n.t('navigation.process_analysis'),
      icon: 'auto_graph',
      path: '/application/process-analysis',
      show: true,
    },
    {
      id: GeneralViewNames.WorkPeriods,
      label: i18n.t('navigation.work_periods'),
      icon: 'calendar_month',
      path: '/application/work-periods',
      show: true,
    },
    {
      id: GeneralViewNames.Adherence,
      label: i18n.t('navigation.adherence'),
      icon: 'emergency',
      path: '/application/adherence',
      show: true, // Risk Analysis is behind a useAI flag within Adherence Component
    },
    {
      id: GeneralViewNames.Integrations,
      label: i18n.t('navigation.integrations'),
      icon: 'hub',
      path: '/application/data-management',
      show: true,
    },
  ];

  return navItems;
}
